// src/components/dnd/ListManager.tsx

import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd'
import { CSSProperties, ReactNode } from 'react'

type Props = {
  items: any[]
  render: (item: any) => ReactNode
  onDragEnd: (from: number, to: number) => void
  direction?: 'vertical' | 'horizontal'
  style?: CSSProperties
  maxItems?: number
  gap?: number
}

export const ListManager = ({
  items,
  render,
  onDragEnd,
  direction = 'vertical',
  style,
  maxItems = 3,
  gap = 10,
}: Props) => {
  const handleEnd = result => {
    if (!result?.destination) return
    const from = result.source.index
    const to = result.destination.index
    if (from === to) return
    onDragEnd(from, to)
  }

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${maxItems}, minmax(0, 1fr))`,
    gap,
    alignItems: 'start',
    ...(style || {}),
  }

  return (
    <DragDropContext onDragEnd={handleEnd}>
      <Droppable droppableId={'list-manager'} direction={direction}>
        {provided => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={gridStyle}
          >
            {items?.map((item, index) => (
              <Draggable
                key={String(item.id)}
                draggableId={String(item.id)}
                index={index}
              >
                {p => (
                  <div
                    ref={p.innerRef}
                    {...p.draggableProps}
                    {...p.dragHandleProps}
                    style={{
                      ...p.draggableProps.style,
                      minWidth: 0,
                    }}
                  >
                    {render(item)}
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}
